import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

import { Popper, PopperProps } from 'components/v2';

import HubJr from './HubJr';

const styles = createStyles({
  root: {
    width: 370,
    height: 572,
  },
});

export interface PopperHubJrProps
  extends Omit<PopperProps, 'classes' | 'children' | 'onClickAway'>,
    WithStyles<typeof styles> {
  onClose: () => void;
}

const PopperHubJr: React.FC<PopperHubJrProps> = ({ classes, className, onClose, ...rest }) => (
  <Popper className={classnames(classes.root, className)} data-lh-id="hubJr-popper" {...rest}>
    <HubJr onClose={onClose} />
  </Popper>
);

export default withStyles(styles)(PopperHubJr);
